import { connect } from 'react-redux';
import { NoShowDialog as Component } from './NoShowDialog';

const mapStateToProps = (state) => ({
  consumerId: state.calendar.inlineClientForm.id,
});

export const NoShowDialog = connect(mapStateToProps)(Component);
